

import { PageModel, Project } from '@brg/api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchFolderData, fetchFolders } from 'shared/actions/folderProjectsActions';
import { FolderT } from 'shared/pages/designer/components/tabs/const';

export enum ProfileFoldersProps {
    cloud = 'cloud',
    create = 'create',
    edit = 'edit',
    projects = 'projects',
}

interface IFolderSlice {
    currentFolder: ProfileFoldersProps;
    data: any,
    foldersList: FolderT[],
    isLoading: boolean,
    prevFolder: any,
    cloudVisible: false,
    defaultTabInit: boolean,
    prevFilter?: any
}

const initialState = {
    currentFolder: ProfileFoldersProps.cloud,
    data: {},
    foldersList: [],
    isLoading: false,
    prevFolder: null,
    cloudVisible: false,
    defaultTabInit: false,
    prevFilter: null
} as IFolderSlice;

const ProfileFoldersSlice = createSlice({
    name: 'folders',
    initialState,
    reducers: {
        resetFolderProjects: (state) => {
            state.data = {}
        },
        setCurrentFolder(state, action: PayloadAction<ProfileFoldersProps>) {
            state.currentFolder = action.payload;
        },
        setFolderData: (state, action) => {
            state.data = action.payload
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setPrevFolder: (state, action) => {
            state.prevFolder = action.payload;
        },
        setCloudButtonStatus:(state, action) => {
            state.cloudVisible = action.payload;
        },
        setDefaultTabInit: (state, action) => {
            state.defaultTabInit = action.payload;
        },
        setFolders: (state, action) => {
            state.foldersList = action.payload
        },
    },
    extraReducers: {
        [fetchFolderData.fulfilled.toString()]: (state, action) => {
            state.data = {data: action.payload.data, paging: action.payload.paging}
            state.isLoading = false
        },
        [fetchFolderData.rejected.toString()]: (state) => {
            state.isLoading = false
        },
        [fetchFolderData.pending.toString()]: (state) => {
            state.isLoading = true
        },
        [fetchFolders.fulfilled.toString()]: (state, action) => {
            state.foldersList = action.payload?.data
            state.isLoading = false
        },
        [fetchFolders.rejected.toString()]: (state) => {
            state.isLoading = false
        },
        [fetchFolders.pending.toString()]: (state) => {
            state.isLoading = true
        },
    }
});

export const { setCurrentFolder, setFolderData, setIsLoading, setPrevFolder, setCloudButtonStatus, setDefaultTabInit, setFolders, resetFolderProjects } = ProfileFoldersSlice.actions;
export const ProfileFoldersSelector = (store: { folders: IFolderSlice }): IFolderSlice => store.folders;
export default ProfileFoldersSlice;


import { PageModel, Project } from '@brg/api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchFolderData, fetchFolders } from 'shared/actions/folderProjectsActions';
import { FolderT } from 'shared/pages/designer/components/tabs/const';

export enum ProfileFoldersProps {
    cloud = 'cloud',
    create = 'create',
    edit = 'edit',
    projects = 'projects',
}

interface IFolderSlice {
    currentFolder: ProfileFoldersProps;
    data: any,
    foldersList: FolderT[],
    isLoading: boolean,
    prevFolder: any,
    cloudVisible: false,
    defaultTabInit: boolean,
    prevFilter?: any
}

const initialState = {
    currentFolder: ProfileFoldersProps.cloud,
    data: {},
    foldersList: [],
    isLoading: false,
    prevFolder: null,
    cloudVisible: false,
    defaultTabInit: false,
    prevFilter: null
} as IFolderSlice;

const ProfileFoldersSlice = createSlice({
    name: 'folders',
    initialState,
    reducers: {
        resetFolderProjects: (state) => {
            state.data = {}
        },
        setCurrentFolder(state, action: PayloadAction<ProfileFoldersProps>) {
            state.currentFolder = action.payload;
        },
        setFolderData: (state, action) => {
            state.data = action.payload
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setPrevFolder: (state, action) => {
            state.prevFolder = action.payload;
        },
        setCloudButtonStatus:(state, action) => {
            state.cloudVisible = action.payload;
        },
        setDefaultTabInit: (state, action) => {
            state.defaultTabInit = action.payload;
        },
        setFolders: (state, action) => {
            state.foldersList = action.payload
        },
    },
    extraReducers: {
        [fetchFolderData.fulfilled.toString()]: (state, action) => {
            state.data = {data: action.payload.data, paging: action.payload.paging}
            state.isLoading = false
        },
        [fetchFolderData.rejected.toString()]: (state) => {
            state.isLoading = false
        },
        [fetchFolderData.pending.toString()]: (state) => {
            state.isLoading = true
        },
        [fetchFolders.fulfilled.toString()]: (state, action) => {
            state.foldersList = action.payload?.data
            state.isLoading = false
        },
        [fetchFolders.rejected.toString()]: (state) => {
            state.isLoading = false
        },
        [fetchFolders.pending.toString()]: (state) => {
            state.isLoading = true
        },
    }
});

export const { setCurrentFolder, setFolderData, setIsLoading, setPrevFolder, setCloudButtonStatus, setDefaultTabInit, setFolders, resetFolderProjects } = ProfileFoldersSlice.actions;
export const ProfileFoldersSelector = (store: { folders: IFolderSlice }): IFolderSlice => store.folders;
export default ProfileFoldersSlice;
